// src/contexts/geral/UsuarioContext.js
import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';
import UsuarioSearch from '../../pages/geral/UsuarioSearch';

const UsuarioContext = createContext();

export const useUsuario = () => {
    const context = useContext(UsuarioContext);
    if (!context) {
        throw new Error('useUsuario must be used within a UsuarioProvider');
    }
    return context;
};

export const UsuarioProvider = ({ children }) => {
    const [usuarios, setUsuarios] = useState([]);
    //const [usuarioLogado, setUsuarioLogado] = useState();
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();
    const [showSearchModalUsuario, setShowSearchModalUsuario] = useState(false);
    const tempOnSelectUsuarioRef = useRef(null);

    // Função para abrir o modal e retornar o usuário selecionado
    const showUsuarioSearch = () => {
        return new Promise((resolve) => {
            setShowSearchModalUsuario(true);

            // Callback para resolver a Promise com o usuário selecionado
            const handleSelect = (usuarioSelect) => {
                setShowSearchModalUsuario(false);
                resolve(usuarioSelect || null); // Retorna o usuário ou null
            };

            // Passa o handleSelect para o UsuarioSearch via estado temporário
            tempOnSelectUsuarioRef.current = handleSelect;
        });
    };

    // Estado temporário para armazenar o callback de seleção

    const handleCloseSearchModal = () => {
        setShowSearchModalUsuario(false);
        tempOnSelectUsuarioRef.current = null; // Limpa o callback após fechar
    };


    useEffect(() => {
        const fetchDataFromAPI = async () => {
            try {
                const result = await fetchData('/Usuario');
                setUsuarios(result);
            } catch (error) {
                console.error("Erro ao buscar usuários:", error);
            }
        };
        fetchDataFromAPI();
    }, []);

    const addUsuario = async (usuario) => {
        try {
            const result = await postData('/Usuario', usuario);
            setUsuarios([...usuarios, result]);
            showAlert('Usuário adicionado com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar usuário:", error);
            showAlert('Erro ao adicionar usuário!', 'danger');
            showMessage(error?.message || error);
            throw error.data || error;
        }
    };

    const updateUsuario = async (usuario) => {
        try {
            const result = await putData('/Usuario', usuario);
            setUsuarios(usuarios.map(u => u.id === usuario.id ? result : u));
            showAlert('Usuário atualizado com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar usuário:", error);
            showAlert('Erro ao atualizar usuário!', 'danger');
            showMessage(error?.message || error);
            throw error.data || error;
        }
    };

    const deleteUsuario = async (id) => {
        try {
            await deleteData('/Usuario', { usuarioId: id });
            setUsuarios(usuarios.filter(u => u.id !== id));
            showAlert('Usuário excluído com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir usuário:", error);
            showAlert('Erro ao excluir usuário!', 'danger');
            throw error.data || error;
        }
    };

    const handleSelectUsuario = () => {
        setShowSearchModalUsuario(false);
    };

    const handleSelectUsuarioSearch = (usuarioSelect) => {
        const onSelect = tempOnSelectUsuarioRef.current || handleSelectUsuario;
        onSelect(usuarioSelect);
    };

    return (
        <UsuarioContext.Provider value={{
            usuarios,
            //usuarioLogado,
            addUsuario,
            updateUsuario,
            deleteUsuario,
            showUsuarioSearch        
        }}>
            {children}            
            <UsuarioSearch
                show={showSearchModalUsuario}
                onHide={handleCloseSearchModal}
                onSelectUsuario={handleSelectUsuarioSearch} // Usa o callback temporário se disponível
            />
        </UsuarioContext.Provider>
    );
};
